<template>
	<div class="login_view_box">
		<div class="login_form_box">
			<div class="header_box">
				<!-- <img :src="getLogoConfig.logoImg" alt="" style="width:120px;vertical-align:middle">
			<h1>{{ getPlatformName.title }}</h1> -->
				<img :src="defaultTitle" alt="" style="" />
			</div>
			<div class="login_box flex-cen">
				<div class="form_box">
					<div class="header_tab_box m-b-20">
						<div v-for="(item, index) in tabList" :key="index" :class="{ active: active === index }" class="title">
							{{ item }}
						</div>
					</div>
					<div class="register_form_box">
						<el-form :model="registerRuleForm" :rules="rules" ref="registerRuleForm" label-width="140px" class="demo-registerRuleForm" label-position="left">
							<el-form-item label="用户名" prop="username" required>
								<el-input v-model="registerRuleForm.username" placeholder="您的账户名和登录名"></el-input>
							</el-form-item>
							<el-form-item label="真实姓名" required>
								<el-input v-model="registerRuleForm.nickName" placeholder="您的真实姓名"></el-input>
							</el-form-item>

							<el-form-item label="手机号码" prop="phoneNumber" required>
								<el-input v-model="registerRuleForm.phoneNumber" placeholder="请输入手机号码"></el-input>
							</el-form-item>
							<el-form-item label="邮 箱" prop="email" v-if="registerRuleForm.registerIdentity === '1'">
								<el-input v-model="registerRuleForm.email" placeholder="请输入邮箱"></el-input>
							</el-form-item>
							<el-form-item label="单位" required>
								<el-input v-model="registerRuleForm.company" placeholder="请输入单位全称"></el-input>
							</el-form-item>
							<el-form-item label="身份证号" required>
								<el-input v-model="registerRuleForm.identityCard" placeholder="请输入身份证号"></el-input>
							</el-form-item>
							<el-form-item label="设置密码" prop="password">
								<el-input type="password" v-model="registerRuleForm.password" placeholder="密码6-16位，区分大小写"></el-input>
							</el-form-item>
							<el-form-item label="确认密码" prop="confirmPassword">
								<el-input type="password" v-model="registerRuleForm.confirmPassword" placeholder="密码6-16位，区分大小写"></el-input>
							</el-form-item>
							<el-form-item label="验证码">
								<el-input placeholder="输入验证码" style="margin-right: 15px" size="large" v-model="registerRuleForm.code" @keyup.enter.native="getLogin"> </el-input>
								<img :src="codeUrl" @click="getClientFunc" class="login-code-img" />
							</el-form-item>
							<!-- <div class="register-form-agreement">
							<el-checkbox v-model="registerAgreement">我已阅读并同意
								<el-link type="primary" :underline="false">《商业遥感交易服务平台用户协议》</el-link>
							</el-checkbox>
						</div> -->
							<div class="submit_btn_box">
								<el-button type="primary" style="width: 100%" @click="submitForm('registerRuleForm')">注 册</el-button>
								<div class="toLogin m-t-10" @click="toLoginFn()">使用已有账号登录</div>
							</div>
						</el-form>
					</div>
				</div>
			</div>
			<!-- <div class="footer_box flex-cen">
			<div class="footer_view_box">
				<div class="footer_serve_box m-b-10">
					<span>帮助</span><span>隐私</span><span>条款</span>
				</div>
				<div>copyright © {{ (new Date()).getFullYear() }} 高分中心 版权所有 |
					京ICP备20003293号-3 | 京公网安备 11010502042296号</div>
			</div>
		</div> -->
		</div>
	</div>
</template>

<script>
import crypto from '@/utils/Crypto'
import Cookie from '@/utils/cookie'
import smsSend from '@/components/SmsSend'
import { mapGetters } from 'vuex'

export default {
	name: 'register',
	components: {
		smsSend
	},
	data() {
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('请再次输入密码'))
			} else if (value !== this.registerRuleForm.password) {
				callback(new Error('两次输入密码不一致!'))
			} else if (value.length < 6 || value.length > 16) {
				callback(new Error('密码必须在6位到16位之间!'))
			} else {
				callback()
			}
		}

		return {
			defaultTitle: require('@/assets/imgs/newHome/位图.png'),
			active: 0,
			tabList: ['注册'],
			registerTypeList: [
				{ label: '个人', value: '1' },
				{ label: '企事业单位', value: '2' },
				{ label: '政府', value: '3' }
			],
			registerRuleForm: {
				registerIdentity: '1',
				username: '',
				// companyName: '',
				// companyLicenseCode: '',
				company: '',
				email: '',
				organizationName: '',
				organizationAddress: '',
				organizationCode: '',
				phoneNumber: '',
				code: '',
				password: '',
				idCode: '',
				confirmPassword: ''
			},
			codeUrl: '',

			registerAgreement: true,
			btnText: '获取验证码',
			btnBool: false,
			rules: {
				// registerIdentity: [
				// 	{ required: true, message: '请选择注册类型', trigger: 'change' }
				// ],
				username: [{ required: true, message: '请输入您的账户名和登录名', trigger: 'blur' }],
				nickName: [{ required: true, message: '请输入您的真实姓名', trigger: 'blur' }],
				company: [{ required: true, message: '请输入单位名称', trigger: 'blur' }],
				// companyLicenseCode: [
				// 	{ required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
				// ],
				email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
				// organizationName: [
				// 	{ required: true, message: '请输入机构名称', trigger: 'blur' },
				// ],
				// organizationAddress: [
				// 	{ required: true, message: '请输入机构地址', trigger: 'blur' },
				// ],
				identityCard: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
				phoneNumber: [{ required: true, message: '请输入手机号码', trigger: 'blur' }],
				// code: [
				// 	{ required: true, message: '请输入验证码', trigger: 'blur' },
				// ],
				password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
				confirmPassword: [{ required: true, validator: validatePass, trigger: 'blur' }]
			}
		}
	},
	created() {
		console.log(this.$const.userInfo.register, '地址')
	},
	computed: {
		...mapGetters(['getLogoConfig', 'getPlatformName'])
	},
	mounted() {
		this.getClientFunc()
	},
	methods: {
		async getClientFunc() {
			let params = {}
			try {
				let res = await this.$http.get(this.$const.common.getClient, params)
				if (res && res.code == 200) {
					this.codeUrl = 'data:image/gif;base64,' + res.img
					this.registerRuleForm.uuid = res.uuid
					console.log('---', this.$route.query.redirect)
				}
			} catch (error) {
				console.log(error)
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate(async (valid) => {
				if (valid) {
					if (this.registerAgreement) {
						try {
							// this.registerRuleForm.password = crypto.encrypt(this.registerRuleForm.password);
							// this.registerRuleForm.confirmPassword = crypto.encrypt(this.registerRuleForm.confirmPassword);
							let res = await this.$http.post(this.$const.common.getregister, this.registerRuleForm)
							if (res && res.code == 200) {
								await this.$message.success(this.$PubText.registerSuccess)
								// await this.$store.dispatch("user/updateuserInfo", {
								//   username: this.registerRuleForm.username
								// });
								Cookie.set('PIE_MALL_Token', res.token)
								// await this.$store.dispatch("user/getUserINFO", {})
								// await this.$store.dispatch("shoppingCart/getCartINFO", {})
								await this.$router.push('/login')
							}
						} catch (e) {
							console.log(e)
						}
					} else {
						this.$message.warning(this.$PubText.agreementTip)
					}
				} else {
					return false
				}
			})
		},
		resetForm(e) {
			this.$refs['registerRuleForm'].resetFields()
			this.registerRuleForm.registerIdentity = e
		},
		toLoginFn() {
			this.$router.push('login')
		}
	}
}
</script>

<style lang="scss" scoped>
.login_view_box {
	min-width: 1200px;
	width: 100%;
	height: 100vh;
	min-height: 800px;
	background: url('../../assets/imgs/login/moonBG.jpg');
	background-size: 100% 100%;

	.login_form_box {
		width: 100%;
		height: 100%;

		.header_box {
			display: flex;
			align-items: center;
			height: 15%;
			padding-left: 5vw;

			// img {
			// 	width: 60px;
			// }

			h1 {
				font-size: 40px;
				color: #ffffff;
				font-weight: 400;
			}
		}

		.login_box {
			height: 75%;
			padding: 20px 0;
			box-sizing: border-box;

			.form_box {
				width: 500px;
				min-height: 400px;
				background: rgba(255, 255, 255, 0.7);
				border-radius: 8px;
				padding: 20px;
				box-sizing: border-box;

				.header_tab_box {
					width: 100%;
					height: 30px;
					display: flex;
					position: relative;

					.title {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 16%;
						font-size: 20px;
						cursor: pointer;
						user-select: none;
					}

					.active {
						&::after {
							content: '';
							display: block;
							width: 16%;
							height: 3px;
							background: #0e81e5;
							position: absolute;
							bottom: -5px;
						}
					}
				}

				.register_form_box {
					/deep/ .el-form-item {
						margin-bottom: 16px;
						padding-left: 5px;
						padding-right: 0;
						border: 1px solid #409eff;

						.el-input {
							input {
								background-color: transparent;
								border: none;
								padding: 0;
								border-radius: 0;

								&:hover {
									border-color: #409eff;
								}

								&::placeholder {
									color: #5c5c5c;
								}
							}
						}
					}

					.verification_code {
						width: 100%;
					}

					.register-form-agreement {
						margin-bottom: 20px;
						text-align: center;

						.el-checkbox__label {
							> .el-link {
								margin-top: -4px;
							}
						}
					}

					.submit_btn_box {
						width: 100%;
						height: 60px;
						text-align: center;

						.toLogin {
							font-size: 14px;
							cursor: pointer;
							text-align: right;
						}
					}
				}
			}
		}
		.register_box {
			height: 75%;
			padding: 20px 0;
			box-sizing: border-box;
		}

		.footer_box {
			min-width: 1200px;
			width: 100%;
			height: 10%;
			flex-direction: column;

			.footer_view_box {
				width: 720px;
				color: #fff;
				text-align: center;
				cursor: pointer;

				.footer_serve_box {
					> span {
						margin-right: 32px;

						&:last-child {
							margin-right: 0;
						}
					}
				}
			}
		}
	}
}
.login-code-img {
	//   height: 40px;
}
</style>